import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "nav-shell" }
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = {
  id: "start",
  class: "hero"
}
const _hoisted_4 = { class: "hero-inner" }
const _hoisted_5 = { class: "hero-actions" }
const _hoisted_6 = {
  href: "tel:+49123456789",
  class: "btn primary"
}
const _hoisted_7 = { class: "hero-meta" }
const _hoisted_8 = { class: "rating-card" }
const _hoisted_9 = {
  id: "preise",
  class: "menu-section section-pad"
}
const _hoisted_10 = { class: "service-grid" }
const _hoisted_11 = { class: "service-card-top" }
const _hoisted_12 = { class: "service-icon" }
const _hoisted_13 = { class: "service-number" }
const _hoisted_14 = { class: "service-category" }
const _hoisted_15 = { class: "service-card-footer" }
const _hoisted_16 = ["aria-label"]
const _hoisted_17 = { class: "menu-note" }
const _hoisted_18 = { class: "experience" }
const _hoisted_19 = { href: "tel:+49123456789" }
const _hoisted_20 = { class: "quote" }
const _hoisted_21 = {
  id: "besuch",
  class: "visit section-pad"
}
const _hoisted_22 = { class: "visit-grid" }
const _hoisted_23 = {
  id: "termin",
  class: "reservation"
}
const _hoisted_24 = { class: "contact-choice-grid" }
const _hoisted_25 = {
  class: "contact-choice",
  href: "tel:+49123456789"
}
const _hoisted_26 = {
  class: "contact-choice",
  href: "https://instagram.com/muster_nagelstudio",
  target: "_blank",
  rel: "noopener"
}
const _hoisted_27 = {
  href: "https://instagram.com/muster_nagelstudio",
  target: "_blank",
  rel: "noopener",
  "aria-label": "Instagram"
}

import { onMounted, onBeforeUnmount, ref } from 'vue';
import { ArrowRight, Check, Clock3, Gem, Hand, Instagram, MapPin, Menu, Palette, Phone, ShieldCheck, Sparkles, Star, WandSparkles, X } from 'lucide-vue-next';
import '@/assets/styles/home.css';
import heroImage from '@/assets/images/muster-nagelstudio-hero-v2.png';


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const mobileOpen = ref(false);
let revealObserver: IntersectionObserver | undefined;

onMounted(() => {
  const elements = document.querySelectorAll('main section, .service-card, .visit-grid > div');
  elements.forEach((element) => element.classList.add('reveal'));
  revealObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        revealObserver?.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 });
  elements.forEach((element) => revealObserver?.observe(element));
});

onBeforeUnmount(() => revealObserver?.disconnect());

const featuredServices = [
  { icon: Hand, number: '01', category: 'Pflege', name: 'Classic Manicure', description: 'Präzise Nagelform, sanfte Nagelhautpflege und ein natürlich gepflegtes Finish.', price: '32 €', features: ['Form & Nagelhaut', 'Pflege-Finish', '45 Minuten'] },
  { icon: Sparkles, number: '02', category: 'Bestseller', name: 'Shellac Manicure', description: 'Glänzende Farbe mit zuverlässigem Halt – gepflegt, alltagstauglich und sofort trocken.', price: '49 €', features: ['Bis zu 3 Wochen Halt', 'Ablösen inklusive', 'Große Farbauswahl'] },
  { icon: Gem, number: '03', category: 'Gel', name: 'Naturnagelverstärkung', description: 'Stabiler, natürlicher Gelaufbau für schöne Nägel ohne zusätzliche Verlängerung.', price: '58 €', features: ['Individueller Aufbau', 'Wunschform', 'Farbe inklusive'] },
  { icon: WandSparkles, number: '04', category: 'Modellage', name: 'Neumodellage', description: 'Professionelle Verlängerung mit harmonischem Aufbau und einer Form, die zu Ihnen passt.', price: '69 €', features: ['S bis L wählbar', 'Farbe inklusive', 'Persönliche Beratung'] },
  { icon: Palette, number: '05', category: 'Design', name: 'Nail Art', description: 'Von minimalen Linien bis zum Statement-Look – fein gearbeitet und individuell geplant.', price: 'ab 2 €', features: ['French & Babyboomer', 'Chrome & Details', 'Preis je nach Design'] },
  { icon: ShieldCheck, number: '06', category: 'Regeneration', name: 'Removal & Care', description: 'Schonendes Entfernen vorhandener Modellage mit anschließender intensiver Nagelpflege.', price: '15 €', features: ['Schonende Entfernung', 'Aufbaupflege', 'Sauberes Naturfinish'] },
];


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("header", _hoisted_1, [
      _createElementVNode("a", {
        class: "brand",
        href: "#start",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (mobileOpen.value=false))
      }, [...(_cache[6] || (_cache[6] = [
        _createElementVNode("span", { class: "brand-mark" }, "M", -1),
        _createElementVNode("span", null, [
          _createTextVNode("MUSTER-NAGELSTUDIO"),
          _createElementVNode("small", null, "DEMO-WEBSITE")
        ], -1)
      ]))]),
      _createElementVNode("nav", {
        class: _normalizeClass({ open: mobileOpen.value }),
        "aria-label": "Hauptnavigation"
      }, [
        _createElementVNode("a", {
          href: "#studio",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (mobileOpen.value=false))
        }, "Studio"),
        _createElementVNode("a", {
          href: "#preise",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (mobileOpen.value=false))
        }, "Preise"),
        _createElementVNode("a", {
          href: "#besuch",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (mobileOpen.value=false))
        }, "Besuch"),
        _createElementVNode("a", {
          href: "tel:+49123456789",
          class: "nav-cta",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (mobileOpen.value=false))
        }, [
          _createVNode(_unref(Phone)),
          _cache[7] || (_cache[7] = _createTextVNode(" 0123 456789", -1))
        ])
      ], 2),
      _createElementVNode("button", {
        class: "menu-toggle",
        "aria-label": mobileOpen.value ? 'Menü schließen' : 'Menü öffnen',
        onClick: _cache[5] || (_cache[5] = ($event: any) => (mobileOpen.value=!mobileOpen.value))
      }, [
        (mobileOpen.value)
          ? (_openBlock(), _createBlock(_unref(X), { key: 0 }))
          : (_openBlock(), _createBlock(_unref(Menu), { key: 1 }))
      ], 8, _hoisted_2)
    ]),
    _createElementVNode("section", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _cache[12] || (_cache[12] = _createElementVNode("p", { class: "eyebrow" }, [
          _createElementVNode("span"),
          _createTextVNode(" DEMO · MUSTERSTADT")
        ], -1)),
        _cache[13] || (_cache[13] = _createElementVNode("h1", null, [
          _createTextVNode("Schönheit bis"),
          _createElementVNode("br"),
          _createElementVNode("em", null, "in die Fingerspitzen.")
        ], -1)),
        _cache[14] || (_cache[14] = _createElementVNode("p", { class: "hero-copy" }, "Moderne Maniküre, langlebige Gel-Styles und feine Nail Art – mit Ruhe, Präzision und einem Blick für das Detail.", -1)),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("a", _hoisted_6, [
            _createVNode(_unref(Phone)),
            _cache[8] || (_cache[8] = _createTextVNode(" Jetzt anrufen", -1))
          ]),
          _cache[9] || (_cache[9] = _createElementVNode("a", {
            href: "#preise",
            class: "btn ghost"
          }, "Preise entdecken", -1))
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("span", null, [
            _createVNode(_unref(Star)),
            _cache[10] || (_cache[10] = _createTextVNode(" Beispiel-Bewertung: 4,9", -1))
          ]),
          _createElementVNode("span", null, [
            _createVNode(_unref(ShieldCheck)),
            _cache[11] || (_cache[11] = _createTextVNode(" Hygienisch & persönlich", -1))
          ])
        ])
      ]),
      _createElementVNode("div", {
        class: "hero-visual",
        style: _normalizeStyle({backgroundImage:`url(${_unref(heroImage)})`})
      }, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("span", null, [
            _createVNode(_unref(Star))
          ]),
          _cache[15] || (_cache[15] = _createElementVNode("div", null, [
            _createElementVNode("strong", null, "4,9 / 5"),
            _createElementVNode("small", null, "Beispiel-Bewertung")
          ], -1))
        ]),
        _cache[16] || (_cache[16] = _createElementVNode("div", { class: "availability-card" }, [
          _createElementVNode("span"),
          _createElementVNode("div", null, [
            _createElementVNode("strong", null, "Termin vereinbaren"),
            _createElementVNode("small", null, "Telefon oder Instagram")
          ])
        ], -1))
      ], 4)
    ]),
    _cache[44] || (_cache[44] = _createStaticVNode("<section id=\"studio\" class=\"story section-pad\"><div class=\"story-label\">01 <span></span> MUSTER-STUDIO</div><div><h2>Ihr Moment.<br><em>Ihre Handschrift.</em></h2><p>Im Muster-Nagelstudio treffen präzises Handwerk und entspannte Studioatmosphäre aufeinander. Wir nehmen uns Zeit, hören zu und gestalten Nägel, die zu Ihrem Alltag und Ihrem Stil passen.</p><p>Von natürlicher Maniküre bis zum individuellen Design: sorgfältig, typgerecht und ohne Hektik.</p><div class=\"signature\">Muster-Nagelstudio <span>DEMO</span></div></div><div class=\"story-card\"><span>UNSER VERSPRECHEN</span><strong>100%</strong><p>saubere Werkzeuge, hochwertige Produkte und ehrliche Beratung bei jedem Termin.</p></div></section>", 1)),
    _createElementVNode("section", _hoisted_9, [
      _cache[18] || (_cache[18] = _createElementVNode("div", { class: "section-heading" }, [
        _createElementVNode("p", { class: "eyebrow dark" }, [
          _createElementVNode("span"),
          _createTextVNode(" LEISTUNGEN & PREISE")
        ]),
        _createElementVNode("h2", null, [
          _createTextVNode("Sechs Leistungen."),
          _createElementVNode("br"),
          _createElementVNode("em", null, "Ein gepflegtes Gefühl.")
        ]),
        _createElementVNode("p", { class: "menu-intro" }, "Klar beschrieben, transparent kalkuliert und immer inklusive persönlicher Beratung.")
      ], -1)),
      _createElementVNode("div", _hoisted_10, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(featuredServices, (service) => {
          return _createElementVNode("article", {
            key: service.name,
            class: "service-card"
          }, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("span", _hoisted_12, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(service.icon)))
              ]),
              _createElementVNode("span", _hoisted_13, _toDisplayString(service.number), 1)
            ]),
            _createElementVNode("span", _hoisted_14, _toDisplayString(service.category), 1),
            _createElementVNode("h3", null, _toDisplayString(service.name), 1),
            _createElementVNode("p", null, _toDisplayString(service.description), 1),
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(service.features, (feature) => {
                return (_openBlock(), _createElementBlock("li", { key: feature }, [
                  _createVNode(_unref(Check)),
                  _createTextVNode(_toDisplayString(feature), 1)
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("strong", null, _toDisplayString(service.price), 1),
              _createElementVNode("a", {
                href: "#termin",
                "aria-label": `${service.name} anfragen`
              }, [
                _createVNode(_unref(ArrowRight))
              ], 8, _hoisted_16)
            ])
          ])
        }), 64))
      ]),
      _createElementVNode("p", _hoisted_17, [
        _createVNode(_unref(Sparkles)),
        _cache[17] || (_cache[17] = _createTextVNode(" Aufwendige Designs kalkulieren wir transparent vor Beginn der Behandlung.", -1))
      ])
    ]),
    _createElementVNode("section", _hoisted_18, [
      _createElementVNode("div", null, [
        _cache[20] || (_cache[20] = _createElementVNode("p", { class: "eyebrow" }, [
          _createElementVNode("span"),
          _createTextVNode(" ZEIT FÜR SIE")
        ], -1)),
        _cache[21] || (_cache[21] = _createElementVNode("h2", null, [
          _createTextVNode("Leise. Schön."),
          _createElementVNode("br"),
          _createElementVNode("em", null, "Ganz bei Ihnen.")
        ], -1)),
        _cache[22] || (_cache[22] = _createElementVNode("p", null, "Ein warmer Kaffee, Ihre Lieblingsfarbe und 60 Minuten ohne To-do-Liste. Unser Demo-Studio ist ein kleiner Rückzugsort in Musterstadt.", -1)),
        _createElementVNode("a", _hoisted_19, [
          _cache[19] || (_cache[19] = _createTextVNode("Termin telefonisch vereinbaren ", -1)),
          _createVNode(_unref(ArrowRight))
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createVNode(_unref(Star)),
        _cache[23] || (_cache[23] = _createElementVNode("p", null, "„Wunderschönes Ergebnis und eine Atmosphäre, in der man sofort abschaltet.“", -1)),
        _cache[24] || (_cache[24] = _createElementVNode("span", null, "— BEISPIELKUNDIN · MUSTERSTADT", -1))
      ])
    ]),
    _createElementVNode("section", _hoisted_21, [
      _cache[33] || (_cache[33] = _createElementVNode("div", { class: "section-heading" }, [
        _createElementVNode("p", { class: "eyebrow dark" }, [
          _createElementVNode("span"),
          _createTextVNode(" IHR BESUCH")
        ]),
        _createElementVNode("h2", null, [
          _createTextVNode("Wir freuen uns"),
          _createElementVNode("br"),
          _createElementVNode("em", null, "auf Sie.")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", null, [
          _createVNode(_unref(MapPin)),
          _cache[25] || (_cache[25] = _createElementVNode("h3", null, "Demo-Adresse", -1)),
          _cache[26] || (_cache[26] = _createElementVNode("p", null, [
            _createTextVNode("Musterstraße 12"),
            _createElementVNode("br"),
            _createTextVNode("12345 Musterstadt")
          ], -1)),
          _cache[27] || (_cache[27] = _createElementVNode("span", { class: "demo-note" }, "Beispieladresse", -1))
        ]),
        _createElementVNode("div", null, [
          _createVNode(_unref(Clock3)),
          _cache[28] || (_cache[28] = _createElementVNode("h3", null, "Öffnungszeiten", -1)),
          _cache[29] || (_cache[29] = _createElementVNode("p", null, [
            _createTextVNode("Mo–Fr: 09:00–19:00"),
            _createElementVNode("br"),
            _createTextVNode("Sa: 09:00–15:00"),
            _createElementVNode("br"),
            _createTextVNode("Sonntag geschlossen")
          ], -1))
        ]),
        _createElementVNode("div", null, [
          _createVNode(_unref(Phone)),
          _cache[30] || (_cache[30] = _createElementVNode("h3", null, "Kontakt", -1)),
          _cache[31] || (_cache[31] = _createElementVNode("p", null, [
            _createTextVNode("0123 456789"),
            _createElementVNode("br"),
            _createTextVNode("@muster_nagelstudio")
          ], -1)),
          _cache[32] || (_cache[32] = _createElementVNode("a", { href: "tel:+49123456789" }, "Direkt anrufen →", -1))
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_23, [
      _cache[40] || (_cache[40] = _createElementVNode("div", null, [
        _createElementVNode("p", { class: "eyebrow" }, [
          _createElementVNode("span"),
          _createTextVNode(" TERMIN VEREINBAREN")
        ]),
        _createElementVNode("h2", null, "Einfach persönlich."),
        _createElementVNode("p", null, "Für einen Termin erreichen Sie das Muster-Nagelstudio direkt per Telefon oder Instagram. Diese Kontaktdaten dienen ausschließlich als Demo.")
      ], -1)),
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("a", _hoisted_25, [
          _createElementVNode("span", null, [
            _createVNode(_unref(Phone))
          ]),
          _cache[35] || (_cache[35] = _createElementVNode("small", null, "TELEFON", -1)),
          _cache[36] || (_cache[36] = _createElementVNode("strong", null, "0123 456789", -1)),
          _createElementVNode("em", null, [
            _cache[34] || (_cache[34] = _createTextVNode("Jetzt anrufen ", -1)),
            _createVNode(_unref(ArrowRight))
          ])
        ]),
        _createElementVNode("a", _hoisted_26, [
          _createElementVNode("span", null, [
            _createVNode(_unref(Instagram))
          ]),
          _cache[38] || (_cache[38] = _createElementVNode("small", null, "INSTAGRAM", -1)),
          _cache[39] || (_cache[39] = _createElementVNode("strong", null, "@muster_nagelstudio", -1)),
          _createElementVNode("em", null, [
            _cache[37] || (_cache[37] = _createTextVNode("Profil öffnen ", -1)),
            _createVNode(_unref(ArrowRight))
          ])
        ])
      ])
    ]),
    _createElementVNode("footer", null, [
      _cache[43] || (_cache[43] = _createElementVNode("div", { class: "brand" }, [
        _createElementVNode("span", { class: "brand-mark" }, "M"),
        _createElementVNode("span", null, [
          _createTextVNode("MUSTER-NAGELSTUDIO"),
          _createElementVNode("small", null, "DEMO-WEBSITE")
        ])
      ], -1)),
      _createElementVNode("p", null, "© " + _toDisplayString(new Date().getFullYear()) + " Muster-Nagelstudio · Demo-Website", 1),
      _createElementVNode("div", null, [
        _createElementVNode("a", _hoisted_27, [
          _createVNode(_unref(Instagram))
        ]),
        _createVNode(_component_router_link, { to: "/impressum" }, {
          default: _withCtx(() => [...(_cache[41] || (_cache[41] = [
            _createTextVNode("Impressum", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_router_link, { to: "/datenschutz" }, {
          default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
            _createTextVNode("Datenschutz", -1)
          ]))]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})